import React from 'react';
import { connect } from 'react-redux';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import PropTypes from 'prop-types';

const ConditionalRichText = ({ fields, selectedQuote }) => {
  if (fields?.hideForSAP) {
    if (fields.hideForSAP?.value === true && selectedQuote?.productCode === 'SAP') {
      return null;
    }
    if (fields.hideForSAP?.value === false && selectedQuote?.productCode !== 'SAP') {
      return null;
    }
  }
  return <RichText field={fields.content} data-testid={`${fields.testid?.value}-content`} />;
};

const mapStateToProps = (state, props) => ({
  ...props,
  selectedQuote: state.quoteData.selectedQuote,
});

ConditionalRichText.propTypes = {
  fields: PropTypes.shape({
    hideForSAP: PropTypes.shape({ value: PropTypes.bool }),
    content: PropTypes.shape({ value: PropTypes.string }),
    testid: PropTypes.shape({ value: PropTypes.string }),
  }).isRequired,
  selectedQuote: PropTypes.shape({
    productCode: PropTypes.string,
  }),
};

export default connect(mapStateToProps)(ConditionalRichText);
